module.exports = __webpack_public_path__ + "media/store/images/bg-vitrine-aa814a58d7360444ffc219521b44a68e.png";